module.exports = __webpack_public_path__ + "img/wia.f3ebe1d5.png";